<template>
    <spinner-until :condition="loaded">
        <div class="client-reports py-3">
            <!-- TODO: fix styling here, put period selector across from page heading? -->
            <b-row class="px-3 period-selector justify-content-between">
                <h1>Client Reports</h1>
                <b-row>
                    <h2 class="pr-2">Report Period: </h2>
                    <b-form-radio-group buttons size="sm" :options="periodOptions" v-model="selectedPeriod"/>
                </b-row>
            </b-row>

            <h2>Sessions by Provider</h2>
            <span>Sum of Survey Notes sorted by Practitioner</span>
            <b-pagination
                v-if="reports.providerSessions.length > 10"
                v-model="providerSessionsPage"
                :total-rows="reports.providerSessions.length"
                per-page="10"
            />
            <b-table
                :items="reports.providerSessions"
                striped
                per-page="10"
                :current-page="providerSessionsPage"
                :fields="[{key: 'first_name', sortable: true}, {key: 'last_name', sortable: true}, {key: 'session_count', sortable: true}]"
            />

            <h2>Sessions by Note Type</h2>
            <span>Sum of Survey Notes sorted by Note Type</span>
            <b-table
                :items="reports.noteTypeSessions"
                striped
                :fields="[{key: 'note_type', sortable: true}, {key: 'session_count', sortable: true}]"
            />

            <h2>Reasons for Coaching</h2>
            <span>Sum of habits on participants' Wellness Plans (Not affected by selected time period)</span>
            <b-table
                :items="reports.reasonsForCoaching"
                striped
                :fields="[{key: 'reason', sortable: true}, {key: 'count', sortable: true}]"/>


            <h2>Outcome reporting (as change over time)</h2>
            <span>Average of latest scores at the beginning and end of selected time period</span>
            <b-pagination
                v-model="outcomePage"
                :total-rows="reports.outcome.length"
                per-page="10"/>
            <b-table
                :items="reports.outcome"
                striped
                per-page="10"
                :current-page="outcomePage"
                :fields="[
                    { key: 'score_name', sortable: true },
                    { key: 'average_score_start', label: 'Starting Average Score', sortable: true },
                    { key: 'average_score_end', label: 'Current Average Score', sortable: true },
                    { key: 'average_score_delta', label: 'Change in Average Score', sortable: true }
                ]">
                <template #cell(average_score_start)="data">
                    {{ Math.round(data.item.average_score_start * 100) / 100}}
                </template>
                <template #cell(average_score_end)="data">
                    {{ Math.round(data.item.average_score_end * 100) / 100}}
                </template>
                <template #cell(average_score_delta)="data">
                    {{ Math.round(data.item.average_score_delta * 100) / 100}}
                </template>
            </b-table>

            <h2>Referrals</h2>
            <span>Number of participants referred to each resource</span>
            <b-pagination
                v-model="referralsPage"
                :total-rows="reports.referrals.length"
                per-page="10"
            />
            <b-table
                :items="reports.referrals"
                striped
                per-page="10"
                :current-page="referralsPage"
                :fields="[{key: 'resource', sortable: true}, {key: 'plan', sortable: true}, {key: 'count', sortable: true}]"/>

            <!--
            awaiting more details for cost calculation
            <h2>Cost by Provider (Work in Progress)</h2>
            <span>Summed by practice and plan, derived from billing</span>
            -->
        </div>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import moment from 'moment'

/**
 * Page for Client Reports
 */
export default {
    name: 'ClientReports',
    props: {
        practiceId: String // if null, report for all practices
    },
    data() {
        return {
            loaded: true,
            selectedPeriod: 0,
            periodOptions: [
                { text: '1 Month', value: 0 },
                { text: '3 Months', value: 1 },
                { text: '6 Months', value: 2 },
                { text: '12 Months', value: 3 }
            ],
            reports: {},
            providerSessionsPage: 1,
            outcomePage: 1,
            referralsPage: 1,
        }
    },
    computed: {
        periodDates() {
            const end = moment()
            const start = moment()
            switch (this.selectedPeriod) {
                case 0:
                    start.subtract(1, 'months')
                    break
                case 1:
                    start.subtract(3, 'months')
                    break
                case 2:
                    start.subtract(6, 'months')
                    break
                case 3:
                    start.subtract(1, 'years')
                    break
            }
            return {start: start.format('YYYY-MM-DD'), end: end.format('YYYY-MM-DD')}
        },
    },
    methods: {
        async getReports() {
            if (this.practiceId) {
                this.reports = await this.$api.getClientReports(this.periodDates.start, this.periodDates.end, +this.practiceId)
            } else this.reports = await this.$api.getClientReports(this.periodDates.start, this.periodDates.end)
        }
    },
    mounted() {
        this.getReports()
    },
    watch: {
        periodDates() {
            this.getReports()
        }
    }
}
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

.client-reports {
    .period-selector {
        margin-top: 2em;
        .btn-group {
         margin: .5em;
        }
        h2 {
            margin: auto;
        }
        h1 {
            margin-bottom: 0 !important;
        }
    }
    h2 {
        margin-top: 1em;
    }
    .pagination {
        margin: 1em 0;
    }
    .b-table {
        margin-bottom: 3em;
    }
}

</style>
